import React from 'react';
import PropTypes from 'prop-types';
import Button from "../components/button/button";
import Modal from "../components/modal/modal";

var Confirm = function Confirm(_ref) {
  var confirmMessage = _ref.confirmMessage,
      isOpen = _ref.isOpen,
      headerLabel = _ref.headerLabel,
      onConfirmModalCancel = _ref.onConfirmModalCancel,
      onConfirmModalContinue = _ref.onConfirmModalContinue,
      confirmCancelBtnMessage = _ref.confirmCancelBtnMessage,
      confirmContinueBtnMessage = _ref.confirmContinueBtnMessage;

  var renderBody = function renderBody() {
    return React.createElement("div", {
      className: "Confirm"
    }, React.createElement("div", {
      className: "Confirm-Message"
    }, ' ', confirmMessage, ' '), React.createElement(Button, {
      className: "Confirm-CancelBtn",
      active: true,
      disabled: false,
      bsSize: "large",
      bsStyle: "default",
      onClick: onConfirmModalCancel,
      type: "button"
    }, confirmCancelBtnMessage), React.createElement(Button, {
      className: "Confirm-ContinueBtn",
      active: true,
      disabled: false,
      bsSize: "large",
      bsStyle: "default",
      onClick: onConfirmModalContinue,
      type: "button"
    }, confirmContinueBtnMessage));
  };

  return React.createElement(Modal, {
    isOpen: isOpen,
    headerLabel: headerLabel,
    onRequestClose: onConfirmModalCancel,
    shouldCloseOnOverlayClick: true,
    zIndex: 3
  }, renderBody());
};

Confirm.displayName = 'Confirm';
Confirm.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onConfirmModalCancel: PropTypes.func.isRequired,
  onConfirmModalContinue: PropTypes.func.isRequired,
  confirmCancelBtnMessage: PropTypes.string,
  confirmContinueBtnMessage: PropTypes.string,
  headerLabel: PropTypes.string,
  confirmMessage: PropTypes.string.isRequired
};
export default Confirm;